import {
  IControl,
  IField,
  IFormPage,
} from 'app/services/api5-service/api.interface';

import { DropdownDirection } from '@ispui/dropdown';

import { ISPFormState } from 'common/dynamic-form/model';
import {
  DYNAMIC_FORM_ASIDE_SELECTOR,
  DYNAMIC_FORM_HEADER_SELECTOR,
  DYNAMIC_FORM_SCROLLABLE_CONTAINER_SELECTOR,
} from 'common/dynamic-form/services/layout.service';
import { getLayoutPlace } from 'common/dynamic-form/utils/get-layout-place';

/**
 * Get selector for dropdown on dynamic form, depending on field position
 *
 * @param state
 * @param control
 * @param field
 * @param page
 */
export function getDropdownParentSelector(
  state: ISPFormState,
  control: IControl,
  field: IField,
  page?: IFormPage,
): string | undefined {
  const layoutPlace = getLayoutPlace(control, field, page);
  switch (true) {
    case Boolean(state.dropdownParentSelector):
      return state.dropdownParentSelector;
    case layoutPlace === 'header':
      return DYNAMIC_FORM_HEADER_SELECTOR;
    case layoutPlace === 'aside':
      return DYNAMIC_FORM_ASIDE_SELECTOR;
    case layoutPlace === 'content':
      return DYNAMIC_FORM_SCROLLABLE_CONTAINER_SELECTOR;
  }
}

/**
 * Get dropdown direction on dynamic form, depending on field position
 *
 * @param control
 * @param field
 * @param page
 */
export function getDropdownDirection(
  control: IControl,
  field: IField,
  page?: IFormPage,
): DropdownDirection | undefined {
  const layoutPlace = getLayoutPlace(control, field, page);
  return layoutPlace === 'header' ? 'bottom' : undefined;
}
